// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_badges.styl
// module id = 98
// module chunks = 0